module.exports = __webpack_public_path__ + "static/img/banner-dummy.fb058ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-dummy.png
// module id = jyuX
// module chunks = 46